module.exports = __webpack_public_path__ + "img/beer_id-106.4839fa34.png";